module.exports = __webpack_public_path__ + "img/sirima_ehmke_preview.ff7a5560.png";